import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import {
  HomeArticles,
  HomeHero,
  HomeShapes,
  HomeTitle,
  OmniBar,
  Pagewrapper,
} from "../../components";
import HomeNewsletter from "../../components/pages/home/_homenewsletter";
import "./index.scss";

const Home = (props) => (
  <Pagewrapper {...props}>
    <Container className="p-0 border-bottom">
      <Row className="p-0 m-0">
        <Col className="p-0 m-0">
          <HomeTitle />
        </Col>
      </Row>
      <Row className="p-0 m-0">
        <Col xs={12} sm={7} className="p-0 mx-auto">
          <OmniBar showSaveSearchButton={false} />
        </Col>
      </Row>
      <Row className="p-0 m-0">
        <Col xs={12} className="p-0 m-0">
          <HomeShapes />
        </Col>
      </Row>
      <Row className="p-0 m-0">
        <Col xs={12} className="p-0 m-0">
          <HomeArticles />
        </Col>
      </Row>
    </Container>
    <Container fluid className="p-0 m-0 pdl_home_newsletter_container">
      <Row className="p-0 m-0">
        <Col className="p-0 m-0">
          <HomeNewsletter />
        </Col>
      </Row>
    </Container>
    <Container className="p-0">
      <Row className="p-0 m-0">
        <Col className="p-0 m-0">
          <HomeHero />
        </Col>
      </Row>
    </Container>
  </Pagewrapper>
);

export default Home;
